/**
 * 按需加载 QQ 互联 SDK
 * 只在用户点击 QQ 登录时才会加载，避免 SDK 自动初始化时崩溃导致页面报错
 */

let qcLoading = false;
let qcLoaded = false;
let qcCallbacks = [];

/**
 * 加载 QQ 互联 SDK
 * @param {Function} callback - 加载完成后的回调
 */
export function loadQCSDK(callback) {
  // 如果已经加载完成，直接执行回调
  if (qcLoaded && typeof QC !== 'undefined') {
    callback();
    return;
  }

  // 把回调加入队列
  qcCallbacks.push(callback);

  // 如果正在加载中，等待即可
  if (qcLoading) return;
  qcLoading = true;

  var qcScript = document.createElement('script');
  qcScript.src = 'https://connect.qq.com/qc_jssdk.js';
  qcScript.setAttribute('data-appid', '1903780711');
  qcScript.setAttribute('data-redirecturi', 'https://www.cs2club.cn/callback/qq');
  qcScript.charset = 'utf-8';
  qcScript.async = true;

  qcScript.onload = function () {
    qcLoaded = true;
    qcLoading = false;
    // 延迟一点等 QC 完全初始化
    setTimeout(function () {
      qcCallbacks.forEach(function (fn) { fn(); });
      qcCallbacks = [];
    }, 500);
  };

  qcScript.onerror = function () {
    console.warn('[QQConnect] SDK 加载失败，QQ登录功能不可用');
    qcLoading = false;
    qcCallbacks = [];
  };

  document.body.appendChild(qcScript);
}

/**
 * 判断 QC SDK 是否可用
 */
export function isQCAvailable() {
  return qcLoaded && typeof QC !== 'undefined';
}
